import type { FC } from "react";
import { useState } from "react";

import { BasicModal } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import { contactUsModalConfig } from "app/pages/sales-intelligence/common-components/ContactUsModal/configs";
import ModalContent from "app/pages/sales-intelligence/common-components/ContactUsModal/modalContent/ModalContent";
import { GainAccessButton } from "app/pages/sales-intelligence/common-components/GainAccessButton";
import { AssetsService } from "app/services/AssetsService";

import {
    StyledGainAccessBtnWrapper,
    StyledGainAccessContainer,
    StyledGainAccessSubTitle,
    StyledGainAccessTitle,
} from "./styles";

type GainAccessBlockProps = {
    title: string;
    subTitle: string;
    handleGainAccessRedirect: () => void;
    isExploreOurPackages?: boolean;
    imageName?: string;
};

const GainAccessBlock: FC<GainAccessBlockProps> = ({
    title,
    subTitle,
    handleGainAccessRedirect,
    isExploreOurPackages = false,
    imageName = "gain-access-lock.svg",
}) => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);

    return (
        <StyledGainAccessContainer>
            <div>
                <img
                    src={AssetsService.assetUrl(`/images/${imageName}`)}
                    alt="Gain access"
                    width={219}
                />
            </div>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessTitle}
            >
                {title}
            </I18n>
            <I18n
                dangerouslySetInnerHTML
                component={StyledGainAccessSubTitle}
            >
                {subTitle}
            </I18n>
            <StyledGainAccessBtnWrapper>
                <GainAccessButton
                    type="trial"
                    onClick={handleGainAccessRedirect}
                    isExploreOurPackages={isExploreOurPackages}
                    data-automation="si.enrichment.hook.get-access.button"
                />
            </StyledGainAccessBtnWrapper>
            <BasicModal
                isOpen={contactUsModal}
                closeIconConfig={{ show: true, onClick: () => setContactUsModal(false) }}
                customStyles={contactUsModalConfig}
                onRequestClose={() => setContactUsModal(false)}
            >
                <ModalContent
                    title={translate("hook_modal.get_feature.success.title")}
                    subTitle={translate("si.modal.get_feature.success.subtitle.v-2")}
                    buttonText={translate("si.modal.get_feature.success.btn.close")}
                    onClick={() => setContactUsModal(false)}
                />
            </BasicModal>
        </StyledGainAccessContainer>
    );
};

export default GainAccessBlock;
